import { useQuery } from 'data-fetching-client';
import { GET_FORECAST_CATEGORY_CONDITIONAL_PROPERTY_RULES } from '../api/dataFetchingQueries';
import { DEAL_PROPERTIES } from '../constants/CrmSearchConstants';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
export const useForecastCategoryUsage = () => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_FORECAST_CATEGORY_CONDITIONAL_PROPERTY_RULES);
  if (error) {
    logRavenException(error, 'Get Forecast Category Conditional Property Rules');
  }
  const potentialUsages = data && data.forecastCategoryConditionalPropertyRules && data.forecastCategoryConditionalPropertyRules.results || [];
  const usedCategories = potentialUsages.filter(candidate => candidate.controllingField.fieldName === DEAL_PROPERTIES.FORECAST_CATEGORY).map(candidate => candidate.controllingField.fieldValue);
  return {
    data: usedCategories,
    loading,
    error
  };
};